// extracted by mini-css-extract-plugin
export var arrowIcon = "index-module--arrowIcon--VNSiM";
export var bulletText = "index-module--bulletText--f8NSE";
export var container = "index-module--container--A8npy";
export var indicator = "index-module--indicator--B9wR2";
export var listContainer = "index-module--listContainer--obM5h";
export var section = "index-module--section--LjEq3";